import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { settings } from '../models_new/config/application-settings';

@Component({
  selector: 'app-eula-dialog',
  templateUrl: 'eula-dialog.html',
})
export class EulaDialogComponent {
  eulaUrl = settings.eulaUrl;
  constructor(public dialogRef: MatDialogRef<EulaDialogComponent>) {}
}
